export default __webpack_public_path__ + "media/images/synthese-conges-vert-caf7be8af46f1a8dc7fe59c9c94e6616.png";